import { render } from "./Tree.vue?vue&type=template&id=7acb1786"
import script from "./Tree.vue?vue&type=script&lang=ts"
export * from "./Tree.vue?vue&type=script&lang=ts"
script.render = render

export default script